import Home from '.';
import { IRoute } from '../../utils/navigation/routes';
import { Navigate } from 'react-router-dom';
import MobileConsumptionPage from './consumption/mobileConsumption';
import PhoneConsumptionPage from './consumption/phoneConsumption';
import Details from './details';
import SharedData from './details/sharedData';
import Fiber from './fiber';
import FiberTestIFrame from './fiber/iFrameTestVelocity';
import ModalCheckSpeed from './fiber/modalCheckSpeed';
import ModalTestInformation from './fiber/modalTestInformation';
import ModalTestInterpretation from './fiber/modalTestInterpretation';
import ModalSlowConnection from './fiber/modalSlowConnection';
import ModalTipsToImproveConnection from './fiber/modalTipsToImproveConnection';
import BonusAvailable from './bonusAvailable';
import ModalExtraBonus from './bonusAvailable/modalExtraBonus';
import BuyAvailableBonus from './bonusAvailable/buyAvailableBonus';
import AvailableBonusMessage from './bonusAvailable/buyAvailableBonus';
import EnableSharedData from './enableSharedData';
import ExtraBonusDetails from './details/extraBonusDetails';
import EnableSharedDataMessage from './enableSharedData/enableSharedDataMessage';
import ExtraExpenseDetails from './details/extraExpenseDetails';
import Devices from './devices/List';
import DevicesDetails from './devices/Detail';

const isLoggedIn = Boolean(sessionStorage.getItem('login-state')) || false;
const typeUser = new URLSearchParams(window.location.search).get('clientType') || false;
const _isLoggedIn = (path: string) => {
    const pathLogged = typeUser ? `/${path}?clientType=${typeUser}` : '/home';
    return isLoggedIn ? pathLogged : '/login';
};
export const homeRoutes: IRoute[] = [
    { path: '/', element: <Navigate to={_isLoggedIn('home')} /> },
    { path: '/home', element: <Home /> },
    { path: '/devices', element: <Devices /> },
    { path: '/device-detail', element: <DevicesDetails /> },
    { path: '/mobile', element: <MobileConsumptionPage /> },
    { path: '/phone', element: <PhoneConsumptionPage /> },
    { path: '/mobile/consumption', element: <Details /> },
    { path: '/phone/consumption', element: <Details /> },
    { path: '/mobile/consumption/shared-data', element: <SharedData /> },
    { path: '/fiber', element: <Fiber /> },
    { path: '/fiber/fiber-test-velocity', element: <FiberTestIFrame /> },
    { path: '/fiber/fiber-modal-check-speed', element: <ModalCheckSpeed /> },
    { path: '/fiber/fiber-modal-test-information', element: <ModalTestInformation /> },
    { path: '/fiber/fiber-modal-test-interpretation', element: <ModalTestInterpretation /> },
    { path: '/fiber/fiber-modal-slow-connection', element: <ModalSlowConnection /> },
    { path: '/fiber/fiber-modal-tips-to-improve-connection', element: <ModalTipsToImproveConnection /> },
    { path: '/mobile/bonus-available', element: <BonusAvailable /> },
    { path: '/mobile/bonus-available/feedback', element: <BuyAvailableBonus /> },
    { path: '/bonus-available/bonus-available-bonus-message', element: <AvailableBonusMessage /> },
    { path: '/bonus-available/bonus-available-modal-extra-bonus', element: <ModalExtraBonus /> },
    { path: '/enable-shared-data', element: <EnableSharedData /> },
    { path: '/enable-shared-data/enable-shared-data-message', element: <EnableSharedDataMessage /> },
    { path: '/bonus-extra-details', element: <ExtraBonusDetails /> },
    { path: '/mobile/extra-expense', element: <ExtraExpenseDetails /> },
    { path: '/phone/extra-expense', element: <ExtraExpenseDetails /> },
];
